import Vue from 'vue';
import { Icon, addCollection } from '@iconify/vue2';

import phIcons from '@iconify-json/ph/icons.json';
import lucideIcons from '@iconify-json/lucide/icons.json';
import sliIcons from '@iconify-json/simple-line-icons/icons.json';
import siIcons from '@iconify-json/simple-icons/icons.json';

// componente global
Vue.component('Icon', Icon);

// colecciones
addCollection(phIcons);
addCollection(lucideIcons);
addCollection(sliIcons);
addCollection(siIcons);